import Service from "./Service";

class ClientSettingApiService extends Service {
  constructor() {
    super("api/ClientAppSettings");
  }

  async GetClientAppSettings() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async GetTotalCostMax() {
    let result = await this.get(`/GetTotalCostMax`, (status, data) => {
      return data;
    });
    return result;
  }

  async GetAllowedFileExtension() {
    let result = await this.get(`/GetAllowedFileExtension`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new ClientSettingApiService();
